const questions = {
	1: {
		question: `Does the contract meet the definition of a lease under <a href="https://leasequery.com/gasb-87-lease-accounting-quiz-internal/" target="_blank">GASB 87</b>?`,
		progress: 1,
		info: {
			infoAbbreviated: `
                <b>Note</b><br /><br />
                This may occur when a contract includes both a software component and a capital asset component, in which the capital asset's cost significantly exceeds the software's cost.<br /><br />
				<b>Common Examples</b><br />
                <ul>
                    <li>Renting physical laptops that include operating software</li>
                    <li>Renting smart office equipment (i.e. printer/copier) that includes connectivity to an IT system's network<.</li>
                </ul>
            `,
		},
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/submit',
			navNo: '/gasb-96-SBITA-identifier/prompt/2',
			current: 1,
		},
	},
	2: {
		question: `
			Is your organization <u><i>providing</i></u> the right to use your IT software? Or is your organization <u><i>receiving</i></u> the ability to use a vendor's IT software?
		`,
		progress: 2,
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/submit',
			navNo: '/gasb-96-SBITA-identifier/prompt/3',
			navSbitaTwo: true,
		},
	},
	3: {
		question:
			'Does the contract meet the scoping criteria for GASB Statement No. 94, <i>Public-Private and Public-Public Partnerships and Availability Payment Arrangements?</i>',
		progress: 3,
		info: {
			infoAbbreviated: `
                <b>Note</b><br /><br />
                A "PPP" (Public-Private or Public-Public Partnership) involves a governmental entity contracting with a third-party operator to provide the IT infrastructure to the user.
				<br />
            `,
		},
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/submit',
			navNo: '/gasb-96-SBITA-identifier/prompt/4',
		},
	},
	4: {
		question: `Does the contract's underlying asset qualify as an IT asset?`,
		progress: 4,
		info: {
			infoAbbreviated: `
			<b>Common Examples</b>
			<ul>
				<li>Software as a Service (SaaS) such as LeaseQuery</li>
				<li>Platform as a Service (Paas)</li>
				<li>Infrastructure as a Service (IaaS)</li>
			</ul>
			`,
		},
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/prompt/5',
			navNo: '/gasb-96-SBITA-identifier/submit',
		},
	},
	5: {
		question: 'Does the contract specify a defined, finite subscription term?',
		subQuestion: 'Is at least a portion of the defined term noncancelable?',
		progress: 5,
		info: {
			infoAbbreviated: `
				<b>Note</b><br /><br />
				Some licensing arrangements may provide a perpetual, infinite period of use for end users.
			`,
		},
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/prompt/6',
			navNo: '/gasb-96-SBITA-identifier/submit',
			navSbitaFive: true,
		},
	},
	6: {
		question:
			'Does the contract exclusively provide support services without subscription or access rights to an identifiable IT software solution?',
		progress: 6,
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/submit',
			navNo: '/gasb-96-SBITA-identifier/prompt/7',
		},
		info: {
			infoAbbreviated: `
				<b>Common Scenarios</b><br /><br />
				Some governments may contract with third-party service providers, separate from the provider of the actual software solution, solely for off-site live troubleshooting support or enhanced training and implementation assistance.`,
		},
	},
	7: {
		question: `Does the contract transfer control of the underlying IT assets to the user?`,
		progress: 7,
		info: {
			infoAbbreviated: `
				<b>Transfer of Control</b><br /><br />
				Determining whether control transfers to the user involves ensuring both of the following:<br /><br />
				a. Does the user have the <b>right to obtain the present service capacity</b> from use of the underlying asset?<br /><br />
				&nbsp&nbsp&nbsp&nbsp&nbspEx - Can the user receive/utilize report outputs from the IT system?<br /><br />
				b. Does the user have the <b>right to determine the nature and manner of use</b> of the underlying IT asset?<br /><br />
				&nbsp&nbsp&nbsp&nbsp&nbspEx - Can the user login to the system at its discretion and produce inputs?<br />
			`,
		},
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/prompt/8',
			navNo: '/gasb-96-SBITA-identifier/submit',
		},
	},
	8: {
		question: 'Do you have an exchange or exchange-like transaction?',
		progress: 8,
		navigation: {
			navYes: '/gasb-96-SBITA-identifier/submit',
			navNo: '/gasb-96-SBITA-identifier/submit',
		},
		info: {
			infoAbbreviated: `
			<b>Exchange or Exchange-like Transaction</b><br /><br />
			Per GASB 33, an exchange is a transaction in which each party receives and gives up essentially equal values. In contrast to a “pure” exchange transaction, an exchange-like transaction is one in which the values exchanged, though related, may not be quite equal or in which the direct benefits may not be exclusively for the parties to the transaction. Nevertheless, the exchange characteristics of the transaction are strong enough to justify treating the transaction as an exchange for accounting recognition. SBITAs require each party to receive or give up essentially equal or not quite equal value.
			`,
		},
	},
	submit: {
		question: 'Where would you like to receive results?',
		progress: 10,
	},
}

export default questions
